import { render } from "./ProjectReports.vue?vue&type=template&id=2c26a487"
import script from "./ProjectReports.vue?vue&type=script&lang=js"
export * from "./ProjectReports.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__